import { ExternalLink, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ModalProps } from '../providers/ModalProvider/ModalProvider';
import { Button } from '../shadcn/button';

import PlatformLink from './PlatformLink';

export default function OutlookReminderModal({ onClose }: ModalProps) {
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col gap-4 p-4">
      <Button
        className="absolute top-2 right-2"
        variant="ghost"
        size="icon-xs"
        onClick={onClose}
      >
        <X />
      </Button>

      <div className="flex flex-col">
        <h2>{t('OUTLOOK_REMINDER_TITLE')}</h2>

        <div className="text-muted-foreground text-sm">
          {t('OUTLOOK_REMINDER_DESCRIPTION')}
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <Button asChild className="bg-[#0075DA] hover:bg-[#115EA3]">
          <PlatformLink to="/settings/connections/external" target="_blank">
            {t('CONNECT_OUTLOOK_BUTTON')}

            <ExternalLink />
          </PlatformLink>
        </Button>

        <Button variant="ghost" onClick={onClose}>
          {t('OUTLOOK_REMINDER_LATER_BUTTON')}
        </Button>
      </div>
    </div>
  );
}
